"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// index.ts
var index_exports = {};
__export(index_exports, {
  buildPersonInitials: () => buildPersonInitials,
  extractNames: () => extractNames,
  getUserAgent: () => getUserAgent,
  roundDecimal: () => roundDecimal
});
module.exports = __toCommonJS(index_exports);

// lib/roundDecimal.ts
var roundDecimal = (value) => +value.toFixed(2);

// lib/extractNames.ts
var extractNames = (name) => {
  const firstName = name.trim().split(" ").slice(0, -1).join(" ");
  const lastName = name.trim().split(" ").slice(-1).join(" ");
  return {
    firstName,
    lastName
  };
};

// lib/buildPersonInitials.ts
var buildPersonInitials = (name = "") => {
  const { firstName, lastName } = extractNames(name);
  return `${firstName.charAt(0)}.${lastName.charAt(0)}`;
};

// lib/getUserAgent.ts
var getUserAgent = (userAgent) => {
  if (/android/i.test(userAgent)) {
    return "Android";
  }
  if (/iphone/i.test(userAgent)) {
    return "iOS";
  }
  if (/ipad/i.test(userAgent)) {
    return "iPadOS";
  }
  if (/win/i.test(userAgent)) {
    return "Windows";
  }
  if (/mac/i.test(userAgent)) {
    return "MacOS";
  }
  if (/linux/i.test(userAgent)) {
    return "Linux";
  }
  if (/cros/i.test(userAgent)) {
    return "Chrome OS";
  }
  return "unknown";
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  buildPersonInitials,
  extractNames,
  getUserAgent,
  roundDecimal
});
